export type DaysAndTimesProps = {
  editMode: boolean;
  fields: any;
};

export enum Days {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday'
}

export type FormatDaysOptions = {
  noon: string;
  midnight: string;
};
